import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { Config, Integration, Plan } from '../../models/config.model';

@Component({
    selector: 'app-plan-section',
    templateUrl: './plan-section.component.html',
    styleUrls: ['./plan-section.component.scss'],
})

export class PlanSectionComponent implements OnInit {
    @Output() clicked: EventEmitter<string> = new EventEmitter<string>();
    selected: Plan;
    selectedRangeIndex: number;

    integrationEnabled: boolean = false;
    selectedIntegration: any = null;
    config: Config | null;

    constructor(private sharedDataService: SharedDataService) {}

    onIntegrationToggle(): void {
      this.sharedDataService.setIntegrationEnabled(this.integrationEnabled);
      console.log('Integration enabled:', this.integrationEnabled);
      if (this.integrationEnabled && !this.selectedIntegration) {
          // If integration is enabled and no integration is selected, set default
          if (this.config && this.config.integrations && this.config.integrations.length) {
              const defaultIntegration = this.config.integrations[0];
              console.log('Default integration:', defaultIntegration);
              this.selectedIntegration = defaultIntegration;
              this.sharedDataService.setSelectedIntegration(defaultIntegration);
          }
      } else if (!this.integrationEnabled) {
          // If integration is disabled, reset the selected integration
          this.selectedIntegration = null;
          this.sharedDataService.setSelectedIntegration(null);
      }
    }

    onIntegrationSelect(integration: Integration): void {
        this.selectedIntegration = integration;
        this.sharedDataService.setSelectedIntegration(integration);
    }

    getPlanPrice(plan:Plan, priceRangeIndex: number): string {
      const priceMultiplier = plan.priceMultiplier || 1;
      const priceRange = plan.priceRanges[priceRangeIndex];
      const { max, price } = priceRange;
      if (price == null) {
        return "";
      }
      const perUnit = !!plan.perUnit;
      let totalPrice = Math.round((price * priceMultiplier) / 10) * 10;
      if (perUnit) {
        totalPrice = Math.round(totalPrice * max);
      }
      // If the plan allows integrations and the integration option is selected, add its cost.
      if (plan.allowIntegration && this.integrationEnabled && this.selectedIntegration) {
        totalPrice += this.selectedIntegration.price;
      }
      return totalPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    ngOnInit() {
      this.sharedDataService.getConfig().subscribe(config => {
        this.config = config;
        // If integrations are allowed and integration is enabled, initialize the default if not already set.
        if (this.config && this.config.integrations && this.config.integrations.length) {
          this.sharedDataService.getIntegrationEnabled().subscribe(enabled => {
            this.integrationEnabled = enabled;
            // Check if no integration has been selected and the checkbox is true
            if (this.integrationEnabled && !this.selectedIntegration) {
              const defaultIntegration = this.config.integrations[0];
              this.selectedIntegration = defaultIntegration;
              this.sharedDataService.setSelectedIntegration(defaultIntegration);
            }
          });
        }
      });

      this.sharedDataService.getPlan().subscribe(plan => {
        this.selected = plan;
      });

      // (Other subscriptions remain unchanged.)
      this.sharedDataService.getRangeIndex().subscribe(index => {
        this.selectedRangeIndex = index;
      });

      // Subscribe to the selected integration if it changes.
      this.sharedDataService.getSelectedIntegration().subscribe(integration => {
        this.selectedIntegration = integration;
      });
    }

    onRangeIndexChange(newIndex: number): void {
      this.sharedDataService.setRangeIndex(newIndex);
    }

    iconClass(plan: any, detail: any): string {
        let classes = [];
        if (plan.isPopular && detail.icon === 'plus') {
            classes.push('white-icon');
        }
        if (detail.icon === 'confirmation') {
            classes.push('green-icon');
        }
        // Add more conditions as needed
        return classes.join(' ');
    }

    onChooseClick(e, plan) {
      this.clicked.emit(plan);
    }
}
